import generalService from "@/services/pei/general";
import { getSysparameterByNames } from "@/modules/system-parameter-managment/api";

export default {
  async getPeiAdmendment(context, peiId) {
    const { data } = await generalService.getSAmendmentByPeiId(peiId);
    if (data) {
      context.commit("setPeiAdmendment", data);
    }
  },
  async getPartEvaluationAmendmentServiceById(context, peiId) {
    const { data } = await generalService.getPartEvaluationAmendmentServiceById(
      peiId
    );
    if (data) {
      context.commit("setPeiAdmendmentService", data);
    }
  },
  async getCorrelationParameter(context) {
    const { data } = await getSysparameterByNames({
      parameterNames: ["AllowedAmendmentCorrelationLogic"]
    });
    if (data) {
      context.commit("setCorrelationParameter", data);
    }
  }
};
